<template>
  <v-row
    :column="isColumn"
    class="mb-4"
  >
    <v-col
      no-gutters
      xs12
      :md4="f4"
      :md5="f5"
      :md6="f6"
      :md7="f7"
      :md8="f8"
      :class="{'mr-3': !isColumn, 'mb-5': isColumn}"
    >
      <slot name="first" />
    </v-col>

    <v-col
      xs12
      :md4="s4"
      :md5="s5"
      :md6="s6"
      :md7="s7"
      :md8="s8"
      :class="{'ml-3': !isColumn}"
    >
      <slot name="second" />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    props: {
      reverse: Boolean,
      firstGridSize: { type: Number, default: null },
      secondGridSize: { type: Number, default: null },
      columnScreenSize: { type: String, default: 'smAndDown' }
    },
    data: () => ({
      f4: false,
      f5: false,
      f6: false,
      f7: false,
      f8: false,
      s4: false,
      s5: false,
      s6: false,
      s7: false,
      s8: false
    }),
    computed: {
      isColumn () {
        if (this.columnScreenSize === 'smAndDown') {
          return this.$vuetify.display.smAndDown
        } else if (this.columnScreenSize === 'mdAndDown') {
          return this.$vuetify.display.mdAndDown
        } else if (this.columnScreenSize === 'lgAndDown') {
          return this.$vuetify.display.lgAndDown
        }
        return false
      }
    },
    created () {
      this.firstGridSize
        ? this['f' + this.firstGridSize] = true : this.f6 = true
      this.secondGridSize
        ? this['s' + this.secondGridSize] = true : this.s6 = true
    }
  }
</script>
